import React, { useMemo } from 'react';
import { IDataSource } from 'app/concierge/types';
import { Box } from '@mui/material';
import useBundleTranslation from 'i18n';
import { IDomain } from 'store/conciergeSlice';
import { useSelector } from 'react-redux';

interface IProps {
    dataSource: IDataSource;
}

export default function DataSource({ dataSource }: IProps) {
    const { t } = useBundleTranslation(['app/concierge/widget']);

    const dataSources = dataSource.data_sources;
    const availableDomains = useSelector((state: any) => state.concierge.availableDomains) as IDomain[];

    if (dataSources.length > 1) {
        return null;
    }

    const domains: IDomain[] = useMemo(() => {
        const toolNames = new Set<string>(
            (dataSources || []).map((ds) => ds?.name).filter((n): n is string => typeof n === 'string' && n.length > 0),
        );

        if (toolNames.size === 0) return [];

        return (availableDomains || []).filter((d) => (d.customServices || []).some((svc) => toolNames.has(svc.name)));
    }, [dataSources, availableDomains]);

    if (domains.length === 1) {
        return <Box>{t('message.data_source', { source: domains[0].title })}</Box>;
    }

    return null;
}
